import React from 'react'

const SvgToga = props => (
  <svg width="1em" height="1em" viewBox="0 0 80 80" {...props}>
    <path
      fill={props.fill}
      fillRule="evenodd"
      d="M40 42.901L8.64 33 40 23.095 71.358 33 40 42.901zm24.008 8.026C63.512 52.6 55.374 57 40 57c-15.374 0-23.512-4.4-24-6V39.517l23.398 7.389c.192.062.392.09.592.092L40 47c.006 0 .01-.005.016-.005.196-.002.394-.03.586-.09l23.4-7.388.006 11.41zm15.988-17.952a1.99 1.99 0 0 0-.14-.688c-.028-.072-.066-.131-.102-.2a2.016 2.016 0 0 0-.446-.574 1.861 1.861 0 0 0-.388-.262c-.074-.04-.142-.082-.222-.111-.034-.012-.062-.037-.096-.049l-38-12a2.026 2.026 0 0 0-1.204 0l-38 12c-.034.012-.062.037-.098.049-.078.03-.148.073-.222.111a2 2 0 0 0-.382.258 1.776 1.776 0 0 0-.184.184 2.01 2.01 0 0 0-.26.387c-.038.072-.08.136-.11.212a1.96 1.96 0 0 0-.142.707c0 .248.056.484.142.709.03.075.072.14.11.212.074.137.158.267.26.386a2 2 0 0 0 .566.44c.074.04.144.081.222.113.036.012.064.036.098.047L12 38.254v12.745c0 5.523 12.536 10 28 10s28-4.477 28-10V38.255l8-2.526V51c0 1.1.9 2 2 2s2-.9 2-2V33c0-.008-.004-.016-.004-.024z"
    />
  </svg>
)

export default SvgToga
